angular.module('unergie.main')
.controller('turpeCtrl', ($scope, $state, $uibModal, AlertManager, DataAccessRefTurpe, NgTableParams, Tokens, ErrorCatcher) => {
    $scope.isActive = (state) => $state.is(state)

    const refresh = () =>
        DataAccessRefTurpe.getTurpe().$promise.then((dataRaw) => {
            const data = _.orderBy(dataRaw, 'from_date', 'desc')
            data.forEach((elem) => (elem.from_date = moment(elem.from_date).toDate()))
            $scope.tableParams = new NgTableParams({
                page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 50,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [10, 25, 50, 100], dataset: data })
            return $scope.tableParams
        }).catch(ErrorCatcher)


    $scope.refresh = refresh
    refresh()

    $scope.delete = (turpe) => DataAccessRefTurpe.delTurpe({ id: turpe.id }).$promise.then((data) => refresh()).catch(ErrorCatcher)


    const turpeTemplate = {
        routing_tariff: 'BTINFCUST',
        max_power: 3,
        fixed_part: '',
        from_date: new Date(),
    }
    $scope.turpeFields = {
        routing_tariff: {
            label: 'Tarif d\'acheminement',
            required: true,
            type: 'select',
            enum: [
                {
                    value: 'BTINFCUST',
                    label: 'BTINFCUST',
                },
                {
                    value: 'BTINFMUDT',
                    label: 'BTINFMUDT',
                },
                {
                    value: 'BTINFLU',
                    label: 'BTINFLU',
                },
                {
                    value: 'BTINFLUSC',
                    label: 'BTINFLUSC',
                },
                {
                    value: 'BTINFCU4',
                    label: 'BTINFCU4',
                },
                {
                    value: 'BTINFMU4',
                    label: 'BTINFMU4',
                },
            ],
        },
        max_power: {
            label: 'Puissance',
            required: true,
            type: 'select',
            enum: [
                {
                    value: 3,
                    label: 3,
                },
                {
                    value: 6,
                    label: 6,
                },
                {
                    value: 9,
                    label: 9,
                },
                {
                    value: 12,
                    label: 12,
                },
                {
                    value: 15,
                    label: 15,
                },
                {
                    value: 18,
                    label: 18,
                },
                {
                    value: 24,
                    label: 24,
                },
                {
                    value: 30,
                    label: 30,
                },
                {
                    value: 36,
                    label: 36,
                },
            ],
        },
        fixed_part: {
            label: 'Part fixe',
            required: true,
            type: 'text',
        },
        from_date: {
            label: 'Date d\'effet',
            type: 'date',
        },
    }

    $scope.updateTurpeFields = angular.copy($scope.turpeFields)

    const resetTurpePayload = () => ($scope.turpePayload = angular.copy(turpeTemplate))

    resetTurpePayload()

    $scope.addTurpe = () =>
        DataAccessRefTurpe.addTurpe($scope.turpePayload).$promise.then(() => {
            resetTurpePayload()
            return refresh() }).catch(ErrorCatcher)


    $scope.updateTurpe = function (turpe) {
        const turpePayload = angular.copy(turpe)
        delete turpePayload.id
        return DataAccessRefTurpe.updateTurpe({ id: turpe.id }, turpePayload).$promise.then(() => {
            AlertManager.success('Turpe modifiée')
            return refresh() }).catch(ErrorCatcher)
    }

    $scope.deleteTurpe = (turpe) =>
        DataAccessRefTurpe.delTurpe({ id: turpe.id }).$promise.then(() => {
            AlertManager.success('Turpe supprimée')
            return refresh() }).catch(ErrorCatcher)


    $scope.updateTurpeCons = function (turpe) {
        const turpePayload = angular.copy(turpe)
        delete turpePayload.id

        return DataAccessRefTurpe.updateTurpeCons({ id: turpe.id }, turpePayload).$promise.then(() => {
            AlertManager.success('Turpe modifiée')
            return refresh()
        }).catch(ErrorCatcher)
    }
})
